import { FC } from "react";

import type { DepositsHistory } from "entities/user";

import { formatAddress, formatAmount, formatDate } from "../../lib";
import { tableStyles } from "../finance-history-table";

interface DepositsTableProps {
  deposits: DepositsHistory["deposits"];
}

export const DepositsTable: FC<DepositsTableProps> = ({ deposits }) => {
  if (deposits.length === 0) {
    return <p className={tableStyles.empty}>No deposits yet</p>;
  }

  return (
    <div className={tableStyles.tableWrap}>
      <table className={tableStyles.table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Amount (USD)</th>
            <th>Currency</th>
            <th>Destination Address</th>
            <th>Tx Hash</th>
          </tr>
        </thead>
        <tbody>
          {deposits.map((deposit) => (
            <tr key={deposit.id}>
              <td>{deposit.id}</td>
              <td>{formatDate(deposit.created_at)}</td>
              <td>{formatAmount(deposit.amount)}</td>
              <td>{formatAmount(deposit.amount_usdt)}</td>
              <td>{deposit.currency.toUpperCase()}</td>
              <td className={tableStyles.truncateCell} title={deposit.to_address}>
                {formatAddress(deposit.to_address)}
              </td>
              <td className={tableStyles.truncateCell} title={deposit.tx_hash}>
                {formatAddress(deposit.tx_hash)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
